export default __webpack_public_path__ + "static/tn-feature-tile-travel-25c99207ebf47fc83ef042ae0c0036b5.webp";